import { LocationDetailsSession } from "../api/models/locationDetailsSession";

export class GetLocationsRequest {
    address: Address = new Address();
}

export class GetLocationsResponse {
    existingLocations: Location[];
    error: string;
}

export class Location {
    pickupPointNumber: string;
    pickupPointNumberStatus: string;
    pickupPointNumberName: string;
    addressLineOne: string;
    cityTown: string;
    stateProvince: string;
    postalCode: string;
    countryCode: string;    
}

export class Error {
    Description: string;
    Code: string;
    Url: string;
    Source: string;
}

export class Address {
    AddressLine1: string;
    AddressLine2: string;
    CityTown: string;
    StateProvince: string;
    CountryCode: string;
    PostalCode: string;
}

export class LocationDetailsSessionRequest {
    locationDetails: LocationDetailsSession;
    temporaryLocation: LocationDetailsSession;
}